import { firestore } from "../Firebase";

const chunk = 500;

export default class BatchService {
  static async apply(actions) {
    for (let i = 0; i < actions.length; i += chunk) {
      const sliced = actions.slice(i, i + chunk);
      await BatchService.batchChunk(sliced);
    }
  }

  private static batchChunk(actions) {
    const batch = firestore.batch();
    for (let action of actions) BatchService.setAction(batch, action);
    return batch.commit();
  }

  private static setAction(batch, action) {
    const hasNullArgument = action.args.some((arg) => !Boolean(arg));
    if (hasNullArgument) {
      console.error(
        `Batch ${action.type} with null argument: `,
        ...action.args
      );
      return;
    }

    batch[action.type](...action.args);
  }
}



// WEBPACK FOOTER //
// ./src/common/services/BatchService.ts